import(/* webpackMode: "eager" */ "/home/runner/_work/reservations/reservations/src/app/locations/[slug]/page.tsx");
